import React, { useEffect } from 'react'

// eslint-disable-next-line no-undef
const fluxSky = require("./image/flux-sky.png");
const fluxCard = require("./image/flux-card.png");

const fluxScreen1 = require("./image/flux-screen1.jpg");
const fluxScreen2 = require("./image/flux-screen2.jpg");
const fluxScreen3 = require("./image/flux-screen3.jpg");
const fluxScreen4 = require("./image/flux-screen4.jpg");



const FluxPage = () => {
  useEffect(() => {
    document.title = 'Flux — Find Your Flow in the Chaos of Fate'

    const head = document.head
    const added = []

    // Tailwind CDN
    const tw = document.createElement('script')
    tw.src = 'https://cdn.tailwindcss.com'
    tw.onload = () => {
      // eslint-disable-next-line no-undef
      tailwind.config = {
        theme: {
          extend: {
            fontFamily: { inter: ['Inter', 'sans-serif'] },
            colors: {
              flux: {
                dark: '#1a0b2e', deeper: '#0f0620',
                violet: '#7c3aed', electric: '#a855f7',
                neon: '#c084fc', gold: '#fbbf24', 'gold-soft': '#f59e0b',
              }
            }
          }
        }
      }
    }
    head.appendChild(tw)
    added.push(tw)

    // FontAwesome
    const fa = document.createElement('link')
    fa.rel = 'stylesheet'
    fa.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css'
    head.appendChild(fa)
    added.push(fa)

    // Google Fonts - Inter
    const gpc1 = document.createElement('link')
    gpc1.rel = 'preconnect'
    gpc1.href = 'https://fonts.googleapis.com'
    head.appendChild(gpc1)
    added.push(gpc1)

    const gpc2 = document.createElement('link')
    gpc2.rel = 'preconnect'
    gpc2.href = 'https://fonts.gstatic.com'
    gpc2.crossOrigin = 'true'
    head.appendChild(gpc2)
    added.push(gpc2)

    const gf = document.createElement('link')
    gf.rel = 'stylesheet'
    gf.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap'
    head.appendChild(gf)
    added.push(gf)

    return () => {
      added.forEach(el => el.parentNode && el.parentNode.removeChild(el))
    }
  }, [])

  return (
    <div className="font-inter bg-flux-dark text-white min-h-screen overflow-x-hidden">
      {/* Mesh gradient background overlay */}
      <div className="fixed inset-0 z-0 pointer-events-none">
        <div className="absolute top-0 left-1/4 w-[600px] h-[600px] bg-purple-700/20 rounded-full blur-[120px] animate-pulse" />
        <div className="absolute bottom-1/4 right-1/4 w-[500px] h-[500px] bg-violet-600/15 rounded-full blur-[100px] animate-pulse" style={{ animationDelay: '2s' }} />
        <div className="absolute top-1/2 left-1/2 w-[400px] h-[400px] bg-fuchsia-500/10 rounded-full blur-[80px] animate-pulse" style={{ animationDelay: '4s' }} />
      </div>

      {/* Header / Navbar */}
      <header className="relative z-50">
        <nav className="max-w-7xl mx-auto px-6 py-5 flex items-center justify-between">
          <div className="text-3xl font-extrabold tracking-tight">
            <span className="bg-gradient-to-r from-purple-400 via-violet-400 to-fuchsia-400 bg-clip-text text-transparent drop-shadow-[0_0_20px_rgba(168,85,247,0.5)]">
              Flux
            </span>
          </div>
        </nav>
      </header>

      {/* Hero Section */}
      <section id="hero" className="relative z-10 max-w-7xl mx-auto px-6 pt-16 pb-24 md:pt-24 md:pb-32">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          {/* Text content */}
          <div className="flex-1 text-center lg:text-left">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6">
              <span className="bg-gradient-to-r from-white via-purple-200 to-violet-300 bg-clip-text text-transparent">
                Find Your Flow
              </span>
              <br />
              <span className="text-gray-300 text-3xl md:text-4xl lg:text-5xl font-bold">
                in the Chaos of Fate.
              </span>
            </h1>
            <p className="text-gray-400 text-lg md:text-xl leading-relaxed mb-10 max-w-xl mx-auto lg:mx-0">
              Your personalized cosmic weather station. Navigate daily emotions and destiny with Eastern Astrology &amp; Lenormand.
            </p>

          </div>

          {/* Phone mockups */}
          <div className="flex-1 flex justify-center items-center relative">
            <div className="relative w-full max-w-md">
              {/* Phone 1 - Sky view */}
              <div className="relative z-10 w-52 md:w-60 rounded-[2rem] overflow-hidden shadow-2xl shadow-purple-500/30 border-2 border-white/10 animate-[float_4s_ease-in-out_infinite] mx-auto -mr-8">
                <img
                  src={fluxSky}
                  alt="Flux Sky View"
                  className="w-full h-auto"
                />
              </div>
              {/* Phone 2 - Card view */}
              <div className="absolute top-8 right-0 md:right-4 z-20 w-52 md:w-60 rounded-[2rem] overflow-hidden shadow-2xl shadow-violet-500/30 border-2 border-white/10 animate-[float_4s_ease-in-out_infinite]" style={{ animationDelay: '1s' }}>
                <img
                  src={fluxCard}
                  alt="Flux Card View"
                  className="w-full h-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="relative z-10 max-w-7xl mx-auto px-6 py-20 md:py-28">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            <span className="bg-gradient-to-r from-purple-300 to-violet-400 bg-clip-text text-transparent">
              Unlock the Cosmos
            </span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Four powerful tools to help you navigate the constant flow of fate and emotions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {/* Feature 1 */}
          <div className="group p-8 rounded-3xl bg-white/5 backdrop-blur-md border border-white/10 hover:border-purple-500/30 hover:bg-white/[0.08] transition-all duration-500">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-violet-600 to-purple-700 flex items-center justify-center mb-6 shadow-lg shadow-purple-500/20 group-hover:shadow-purple-500/40 transition-shadow duration-500">
              <i className="fas fa-sun text-xl text-yellow-300" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-white">Cosmic Flow</h3>
            <p className="text-gray-400 leading-relaxed">
              Track your daily energy peaks and valleys with our unique 'Sky' calendar. Visualize the rhythm of the cosmos mapped to your personal chart.
            </p>
            <div className="mt-6 rounded-2xl overflow-hidden border border-white/5">
              <img src={fluxScreen1} alt="Cosmic Flow" className="w-full h-48 object-cover object-top opacity-80 group-hover:opacity-100 transition-opacity duration-500" />
            </div>
          </div>

          {/* Feature 2 */}
          <div className="group p-8 rounded-3xl bg-white/5 backdrop-blur-md border border-white/10 hover:border-purple-500/30 hover:bg-white/[0.08] transition-all duration-500">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-fuchsia-600 to-pink-700 flex items-center justify-center mb-6 shadow-lg shadow-fuchsia-500/20 group-hover:shadow-fuchsia-500/40 transition-shadow duration-500">
              <i className="fas fa-layer-group text-xl text-pink-200" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-white">Lenormand Insights</h3>
            <p className="text-gray-400 leading-relaxed">
              36-card oracle reading for instant clarity on past, present, and future. Let the ancient cards illuminate your path forward.
            </p>
            <div className="mt-6 rounded-2xl overflow-hidden border border-white/5">
              <img src={fluxScreen2} alt="Lenormand Insights" className="w-full h-48 object-cover object-top opacity-80 group-hover:opacity-100 transition-opacity duration-500" />
            </div>
          </div>

          {/* Feature 3 */}
          <div className="group p-8 rounded-3xl bg-white/5 backdrop-blur-md border border-white/10 hover:border-purple-500/30 hover:bg-white/[0.08] transition-all duration-500">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-indigo-600 to-blue-700 flex items-center justify-center mb-6 shadow-lg shadow-indigo-500/20 group-hover:shadow-indigo-500/40 transition-shadow duration-500">
              <i className="fas fa-robot text-xl text-blue-200" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-white">AI Spirit Guide</h3>
            <p className="text-gray-400 leading-relaxed">
              A soulful chat companion powered by deep astrological data. Ask anything about your chart, your day, or your destiny.
            </p>
            <div className="mt-6 rounded-2xl overflow-hidden border border-white/5">
              <img src={fluxScreen3} alt="AI Spirit Guide" className="w-full h-48 object-cover object-top opacity-80 group-hover:opacity-100 transition-opacity duration-500" />
            </div>
          </div>

          {/* Feature 4 */}
          <div className="group p-8 rounded-3xl bg-white/5 backdrop-blur-md border border-white/10 hover:border-purple-500/30 hover:bg-white/[0.08] transition-all duration-500">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-amber-500 to-orange-600 flex items-center justify-center mb-6 shadow-lg shadow-amber-500/20 group-hover:shadow-amber-500/40 transition-shadow duration-500">
              <i className="fas fa-headphones text-xl text-amber-100" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-white">Sonic Resonance</h3>
            <p className="text-gray-400 leading-relaxed">
              Meditation sounds and crystal vibrations to realign your inner flux. Tune into frequencies that harmonize with your cosmic state.
            </p>
            <div className="mt-6 rounded-2xl overflow-hidden border border-white/5">
              <img src={fluxScreen4} alt="Sonic Resonance" className="w-full h-48 object-cover object-top opacity-80 group-hover:opacity-100 transition-opacity duration-500" />
            </div>
          </div>
        </div>
      </section>

      {/* Readings / Testimonial Section */}
      <section id="readings" className="relative z-10 max-w-4xl mx-auto px-6 py-20 md:py-28">
        <div className="relative p-10 md:p-16 rounded-3xl bg-gradient-to-br from-white/[0.06] to-white/[0.02] backdrop-blur-xl border border-white/10">
          {/* Decorative quote marks */}
          <div className="absolute top-6 left-8 text-6xl text-purple-500/20 font-serif leading-none">"</div>
          <div className="text-center">
            <div className="flex justify-center mb-6">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="fas fa-star text-amber-400 text-sm mx-0.5" />
              ))}
            </div>
            <blockquote className="text-xl md:text-2xl font-light text-gray-200 leading-relaxed mb-8 italic">
              Flux helps me understand why I feel the way I do. It's like a weather forecast for my soul.
            </blockquote>
            <div className="flex items-center justify-center gap-3">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-500 to-fuchsia-500 flex items-center justify-center">
                <i className="fas fa-user text-sm text-white" />
              </div>
              <div className="text-left">
                <div className="text-sm font-semibold text-white">Luna M.</div>
                <div className="text-xs text-gray-400">Flux User</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer id="contact" className="relative z-10 border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 py-12">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="text-2xl font-extrabold">
              <span className="bg-gradient-to-r from-purple-400 to-violet-400 bg-clip-text text-transparent">
                Flux
              </span>
            </div>
            <div className="flex items-center gap-6 text-sm text-gray-400">
              <a href="#PrivacyPolicy" className="hover:text-white transition-colors">Privacy Policy</a>
              <a href="#TOSLiAServiceFFluxApp" className="hover:text-white transition-colors">Terms of Service</a>
              <a href="mailto:appworks.ai@gmail.com" className="hover:text-white transition-colors">
                <i className="fas fa-envelope mr-1" />
                appworks.ai@gmail.com
              </a>
            </div>
          </div>
          <div className="text-center mt-8 text-xs text-gray-500">
            © 2026 Flux App. All rights reserved.
          </div>
        </div>
      </footer>

      {/* Global CSS for animations */}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-12px); }
        }
      `}</style>
    </div>
  )
}

export default FluxPage
